
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BriefResource,
  UpdateBriefRequest,
  ValidationError,
} from '../models';
import {
    BriefResourceFromJSON,
    BriefResourceToJSON,
    UpdateBriefRequestFromJSON,
    UpdateBriefRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface GetBriefResourceRequest {
    briefId: string;
}

export interface GetBriefSearchUrlRequest {
    briefId: string;
}

export interface UpdateBriefOperationRequest {
    briefId: string;
    updateBriefRequest: UpdateBriefRequest;
}

/**
 * 
 */
export class BriefApi extends runtime.BaseAPI {

    /**
     * Get a brief resource
          */
    async getBriefResourceRaw(requestParameters: GetBriefResourceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BriefResource>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling getBriefResource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<BriefResource>({
            path: `/brief/api/briefs/{briefId}`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=BriefResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a brief resource
          */
    async getBriefResource(requestParameters: GetBriefResourceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BriefResource> {
        const response = await this.getBriefResourceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Build a prefilled keyword search URL from brief role and location and redirect to it
          */
    async getBriefSearchUrlRaw(requestParameters: GetBriefSearchUrlRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling getBriefSearchUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/brief/api/briefs/{briefId}/search-url`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Build a prefilled keyword search URL from brief role and location and redirect to it
          */
    async getBriefSearchUrl(requestParameters: GetBriefSearchUrlRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.getBriefSearchUrlRaw(requestParameters, initOverrides);
    }

    /**
     * Update a brief
          */
    async updateBriefRaw(requestParameters: UpdateBriefOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BriefResource>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling updateBrief().'
            );
        }

        if (requestParameters['updateBriefRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBriefRequest',
                'Required parameter "updateBriefRequest" was null or undefined when calling updateBrief().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<BriefResource>({
            path: `/brief/api/briefs/{briefId}`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBriefRequestToJSON(requestParameters['updateBriefRequest']),
        }, initOverrides);

        if (response._data) { response._data=BriefResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update a brief
          */
    async updateBrief(requestParameters: UpdateBriefOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BriefResource> {
        const response = await this.updateBriefRaw(requestParameters, initOverrides);
        return response._data;
    }

}
